import React from 'react';
import { SvgIconProps } from '@mui/material';
import { ReactComponent as Logo } from '@shared/assets/thr_logo_light.svg';


export const NewLogoLight: React.FC<SvgIconProps> = (props) => {
  return (
    <Logo {...props} />
  );
};
